import React, { useEffect, useState } from 'react';
import api from '../api';
import { Container, Accordion } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { formatEuro } from '../utils';
import LoadingLogo from '../components/general/LoadingLogo';
import MessageBox from '../components/general/MessageBox';
import { formatCountryLabel } from '../utils/addressForm';

export default function ShippingCostsScreen() {
  const { t, i18n } = useTranslation();
  const [zones, setZones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const selectedLanguage = i18n.resolvedLanguage;

  useEffect(() => {
    const fetchZones = async () => {
      try {
        const { data } = await api.get('/api/zones?pageSize=1000'); // this screen lists every zone, not the first page — /api/zones defaults to 20 per page
        setZones(data);
        setLoading(false);
      } catch (err) {
        setError(err.message || 'Error fetching zones');
        setLoading(false);
      }
    };

    fetchZones();
  }, []);

  return (
    <Container className="small-container">
      <title>{t('shipping-costs-screen-helmet')}</title>

      <h1 className="screen-heading">{t('shipping-costs-screen-heading')}</h1>

      {loading ? (
        <div className="overlay">
          <LoadingLogo />
        </div>
      ) : error ? (
        <MessageBox className="danger-alert">{error}</MessageBox>
      ) : (
        <div>
          <p className="shipping-costs-info">
            {t('shipping-costs-screen-description')}
          </p>

          <Accordion>
            {zones.zones.map((zone, index) => (
              <Accordion.Item eventKey={index.toString()} key={zone._id}>
                <Accordion.Header>
                  <div className="shipping-costs-zone-header">
                    <div className="shipping-costs-zone-name">
                      {selectedLanguage === 'de'
                        ? zone.names.de
                        : zone.names.en}
                    </div>

                    <div className="shipping-costs-zone-price">
                      {formatEuro(zone.price)}
                    </div>
                  </div>
                </Accordion.Header>

                <Accordion.Body>
                  <ul className="shipping-zone-countries-list">
                    {zone.countries.map((country, i) => {
                      // Use the appropriate language based on selectedLanguage
                      const countryData =
                        selectedLanguage === 'de'
                          ? country.names.de
                          : country.names.en;

                      return (
                        <li key={i}>
                          {formatCountryLabel(countryData, '???')}
                        </li>
                      );
                    })}
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      )}
    </Container>
  );
}
